export interface IClientsAnalyticsAPIProps {
  currency: string;
  period: string;
  businessUnitId?: string;
  quarter: string;
}

export interface IClientsAnalyticsChartsProps {
  clientsAnalyticsChartsProps: IClientsAnalyticsAPIProps;
}

export const processPeriod = (period: string) => {
  switch (period.toLowerCase()) {
    case 'quarter':
      return 'Last 12 Months (Quarterly)';
    case 'year':
      return 'Last 3 Years (Yearly)';
    case 'month':
      return 'Last 6 Months (Monthly)';
    default:
      return '';
  }
};

export const getSumOfColumnRecords = (
  tableData,
  columns,
  textTypeColumnFields: string[],
  round?: boolean
) => {
  const getColumnSum = (column) =>
    tableData.reduce((total, row) => total + Number(row[column.field]), 0);

  const columnsWithSum = columns?.map((column) => ({
    ...column,
    headerName: textTypeColumnFields.includes(column.field)
      ? column.headerName
      : `${column.headerName} (${round ? getColumnSum(column)?.toFixed(2) : getColumnSum(column)})`,
  }));
  return columnsWithSum;
};
